<template>
  <div id="EstablishmentRegistration">
    <header style="position: fixed;">
      <div class="inner">
        <router-link to="/">首页</router-link>
      </div>
    </header>
    <div class="registbox">
      <el-form :model="ruleForm" :label-position="labelPosition" status-icon :rules="rules" ref="ruleForm"
        label-width="100px" class="demo-ruleForm">
        <el-form-item label="公司" prop="company_name">
          <el-input type="text" v-model="ruleForm.company_name" placeholder="请输入公司名称" autocomplete="off"
            class="myrulesinput"></el-input>
        </el-form-item>
        <el-form-item label="管理员姓名" prop="user">
          <el-input type="text" v-model="ruleForm.user" placeholder="请输入姓名" autocomplete="off" class="myrulesinput">
          </el-input>
        </el-form-item>
        <el-form-item label="管理员电话" prop="phone">
          <el-input type="tel" v-model="ruleForm.phone" placeholder="请输入电话" autocomplete="off" class="myrulesinput">
          </el-input>
        </el-form-item>
        <el-form-item label="营业执照">
          <el-input accept="image/*" @change="up()" type="file" v-model="ruleForm.information" autocomplete="off"
            id="file" class="myrulesinput">
          </el-input>
        </el-form-item>
        <el-form-item label="管理员账号" prop="account">
          <el-input type="text" v-model="ruleForm.account" placeholder="请输入账号" autocomplete="off" class="myrulesinput">
          </el-input>
        </el-form-item>
        <el-form-item label="管理员密码" prop="password">
          <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码" autocomplete="off"
            class="myrulesinput" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" placeholder="请再次输入密码" autocomplete="off"
            class="myrulesinput" show-password></el-input>
        </el-form-item>
        <el-form-item label="部门:" prop="department">
          <el-input v-model="ruleForm.department" placeholder="请输入部门" class="myrulesinput"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="upload()">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>

    </div>
  </div>
</template>

<script>
  import {
    RegisterView,
    uploadfile,
  } from '../../static/API/API.js'
  export default {
    name: 'EstablishmentRegistration',
    data: function() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validatetel = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入电话'));
        } else {
          if (this.ruleForm.tel !== '') {
            this.$refs.ruleForm.validateField('tel');
          }
          callback();
        }
      };
      var validateusername = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号'));
        } else {
          if (this.ruleForm.username !== '') {
            this.$refs.ruleForm.validateField('username');
          }
          callback();
        }
      };
      var validatenames = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入姓名'));
        } else {
          if (this.ruleForm.name !== '') {
            this.$refs.ruleForm.validateField('name');
          }
          callback();
        }
      };
      return {
        companyid: '',
        show: false,
        department: '',
        positions: '',
        options: [],
        value: '',
        option2: [],
        value2: '',
        sizeForm: {
          user: '',
          pwd: '',
        },
        drawer: false,
        direction: 'btt',
        labelPosition: 'left',
        ruleForm: {
          company_name: '',
          user: '',
          phone: '',
          information: '',
          account: '',
          password: '',
          positions: '',
          department: '',
          checkPass: '',
        },
        rules: {
          username: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }],
          names: [{
              required: true,
              message: '请输入姓名',
              trigger: 'blur'
            },
            {
              min: 2,
              max: 5,
              message: '长度在 2 到 5 个字符',
              trigger: 'blur'
            }
          ],
          pass: [{
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }],
          checkPass: [{
            required: true,
            validator: validatePass2,
            trigger: 'blur'
          }],
          tel: [{
            required: true,
            message: '请输入电话号',
            trigger: 'blur'
          }],
          company: [{
            required: true,
            message: '请输入公司',
            trigger: 'blur'
          }],
          positions: [{
            required: true,
            message: '请输入职务',
            trigger: 'blur'
          }],
          department: [{
            required: true,
            message: '请输入部门',
            trigger: 'blur'
          }],
          department2: [{
            required: true,
            message: '请输入部门',
            trigger: 'blur'
          }]
        },
        setIH: [],
        file: null

      }

    },
    mounted() {

    },
    methods: {
      up() {
        let that =this
        let file = document.querySelector("#file").files[0]
        let fd = new FormData();
        fd.append('file', file); //传文件
        this.$axios.post(uploadfile, fd).then(function(res) {
          console.log(res.data)
         that.file = res.data
         that.ruleForm.information=res.data
        })
      },
      upload() {
        let formModels = this.ruleForm
        let roles = formModels.department
        let params = new URLSearchParams();
        params.append('company_name', formModels.company_name); //公司名字
        params.append('user', formModels.user); //注册人
        params.append('phone', formModels.phone); //注册电话
        params.append('information', formModels.information); //注册资料
        params.append('account', formModels.account); //管理员账号
        params.append('password', formModels.password); //管理员密码
        params.append('department', formModels.department); //管理员部门
        this.$axios.get(RegisterView, {
          params
        }).then(res => {
          this.$notify.info({
            title: '消息',
            message: res.data
          });
          setTimeout(function(){
            // window.location.href = 'http://www.ziyichain.cn/';
          },3000)
        })
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.show = false
        this.ruleForm.department = ''
        this.ruleForm.file = null
        this.file = null

      },
    }
  }
</script>

<style scoped>
  .el-form, .el-form--label-left{
    margin-top: 35%;
    width: 25rem;
  }
  .el-form-item__label{
    color: white !important;
  }
  #EstablishmentRegistration {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    /* padding-top: 40px; */
    /* padding-bottom: 40px; */
    background: url(../../static/images/right.jpg) no-repeat;
    background-size: 100% 100%;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/EstablishmentRegistration.vue